import React from "react"
import VisibilitySensor from 'react-visibility-sensor'

const SectionScrollDetected = ({ onVisisbleChange }) => (
  <VisibilitySensor onChange={onVisisbleChange}>
    <div style={{ fontSize: 1, color: 'transparent' }}>scroll</div>
  </VisibilitySensor>
)

export default SectionScrollDetected